module.exports = __webpack_public_path__ + "img/支付宝.ac9b917e.svg";